import { Utils } from "@/plugins/utils";
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lxd: null,
		insert: false,
		update: false,
		loading: false
	},
	getters: {
		getLxdgrade: state => state.lxd.lxdgrade,
		getLxdest: state => state.lxd.lxdest,
		getLxdcrt: state => state.lxd.lxdcrt,
		lxdmodel(state){
			let lxd =  {...state.lxd}
			if (!!lxd.lxdcodtmin) {
				lxd.lxdcodtmin = Utils.ParseToDate(lxd.lxdcodtmin)
				lxd.lxdcodtmin = moment(lxd.lxdcodtmin).format("YYYY-MM-DDTHH:mm:ssZ");
			}else{
				lxd.lxdcodtmin = null
			}
			if (!!lxd.lxdcortdev) {
				lxd.lxdcortdev = Utils.ParseToDate(lxd.lxdcortdev)
				lxd.lxdcortdev = moment(lxd.lxdcortdev).format("YYYY-MM-DDTHH:mm:ssZ");
			}else{
				lxd.lxdcortdev = null
			}
			lxd.lxdpreclis = lxd.lxdpreclis.join(";")
			lxd.lxdstoclis = lxd.lxdstoclis.join(";")
			lxd.lxdlstclie = lxd.lxdlstclie.join(";")
			lxd.lxdest = lxd.lxdest ?? ""
			lxd.lxdgrade = lxd.lxdgrade ?? ""
			return lxd
		},
		getLxd(state){
			return state.lxd
		},
	},
	mutations: {
		set(state, lxd){
			state.lxd = lxd
			state.lxd.lxdcodtmin = new Date(lxd.lxdcodtmin).toLocaleDateString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
			state.lxd.lxdcortdev = new Date(lxd.lxdcortdev).toLocaleDateString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit'})
			if (lxd)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
		},
		resetLxd(state) {
			state.lxd = null
		},
	},
	actions: {
		async find(store){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get("/OryxPdv/Parameters/Find")
			.then(response => {
				let lxd = Utils.ValidateAxiosResponse(response.data);
				lxd.lxdpreclis = lxd.lxdpreclis.split(";")
				lxd.lxdstoclis = lxd.lxdstoclis.split(";")
				lxd.lxdlstclie = lxd.lxdlstclie.split(";")
				if (lxd.lxdpreclis == "")
					lxd.lxdpreclis = []
				if (lxd.lxdstoclis == "")
					lxd.lxdstoclis = []
				if (lxd.lxdlstclie == "")
					lxd.lxdlstclie = []
				store.commit("set", lxd)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		save(store){
			if (store.state.lxd.lxdpadrao){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			let lxd = store.getters.lxdmodel

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/OryxPdv/Parameters/Insert", lxd )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			let lxd = store.getters.lxdmodel

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/OryxPdv/Parameters/Update", lxd )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete("/OryxPdv/Parameters/Delete")
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
	}
}